<template>
  <form-section>
    <el-row :gutter="30">
      <el-col :span="12">
        <inbox-message-settings-form
          v-if="model.inbox_settings"
          type="android"
          v-model="model"
        ></inbox-message-settings-form>
      </el-col>

      <el-col :span="12">
        <div class="preview-frame">
          <android-inbox-preview
            v-if="model.inbox_settings"
            logo-url="/img/powered_by_XP.png"
            :push-notification-switch="model.inbox_settings.switch"
            :position="model.inbox_settings.position"
            :colors="model.inbox_settings.colors"
          />
        </div>
      </el-col>
    </el-row>
  </form-section>
</template>

<script>
import AndroidInboxPreview from '@/modules/settings/components/AndroidInboxPreview'
import InboxMessageSettingsForm from '@/modules/settings/components/InboxMessageSettingsForm'
import FormSection from '@/common/components/form/FormSection'
import { inboxSettingsAndroid } from '@/modules/settings/enum/AndroidInboxDefaultSettings'
export default {
  name: 'InboxMessageSettingsAndroid',
  components: {
    FormSection,
    AndroidInboxPreview,
    InboxMessageSettingsForm
  },
  props: {
    model: {
      required: true
    }
  },
  mounted() {
    if (this.model.inbox_settings === null) {
      this.model.inbox_settings = { ...inboxSettingsAndroid }
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.preview-frame {
  height: 700px;
}
</style>



// WEBPACK FOOTER //
// src/modules/settings/components/InboxMessageSettingsAndroid.vue